import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { IGetState, TBoardId } from '../../../../../../../../types/types';
import {
    boardUserMetaSetCardPreviewHiddenProperties
} from '../../../../../../../../rest/effects/board/boardUserMetaSetCardPreviewHiddenProperties';
import {
    boardUserMetaSetCardPreviewCustomProperties
} from '../../../../../../../../rest/effects/board/boardUserMetaSetCardPreviewCustomProperties';

export function onReset (
    boardId: TBoardId,
): ThunkAction {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        dispatch(boardUserMetaSetCardPreviewHiddenProperties(boardId, null));
        dispatch(boardUserMetaSetCardPreviewCustomProperties(boardId, null));
    };
    return action;
}
